import React from 'react';
import { Alert, Snackbar } from '@mui/material';
import { useSessionExpiry } from '../hooks/useSessionExpiry';

/**
 * Dismissible warning shown when the signed-in session expires within ~24h
 * (Phase 9, R2.2). Modeled on UpdatesBanner/OfflineBanner. Only render this when
 * a user is logged in. The hard-expiry (401) logout is handled by the data
 * client + WebAuthnContext, not here.
 */
const SessionExpiryBanner: React.FC = () => {
  const { expiringSoon, dismiss } = useSessionExpiry();

  return (
    <Snackbar
      open={expiringSoon}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      onClose={dismiss}
    >
      <Alert
        severity="warning"
        variant="filled"
        onClose={dismiss}
        sx={{ width: '100%' }}
      >
        Your sign-in expires in about a day. Re-authenticate soon to stay signed
        in.
      </Alert>
    </Snackbar>
  );
};

export default SessionExpiryBanner;
